import React from 'react';
import { Tooltip } from '@cowbell/ui';

/** Above the listing's sticky header and chrome, which a default-layer (300) tooltip loses to. */
export const TABLE_CELL_TOOLTIP_LAYER = 1400;

interface TableCellTooltipProps {
  readonly label: React.ReactNode;
  readonly children: React.ReactElement;
}

/**
 * The tooltip on a control inside a listing row.
 *
 * <p>Opens to the left, not above. A listing row sits under a sticky table header, and a tooltip
 * opening upward from a row near the top of the page is drawn into that header and painted over
 * by it — the words end up half behind the column titles, which is worse than no tooltip because
 * it looks broken rather than absent. Sideways there is nothing above to collide with.
 *
 * <p>The z-index is deliberate for the same reason: the header and the listing's own chrome are
 * stacked, and a portalled tooltip still loses to them without it.
 *
 * <p>Shared by every listing. The vendors listing fixed this for its icon cells, and the FNOL
 * queue's delete button was later written with the defaults and shipped the same bug (FIR-21372).
 */
export function TableCellTooltip({ label, children }: TableCellTooltipProps) {
  return (
    <Tooltip
      label={label}
      withArrow
      position="left"
      zIndex={TABLE_CELL_TOOLTIP_LAYER}
    >
      {children}
    </Tooltip>
  );
}
